import classNames from 'classnames';
import Button from '@/shared/components/shared/Button';
import Link from '@/shared/components/shared/Link';
import TeamItem from '@/shared/components/shared/TeamItem';
import Typografed from '@/shared/components/shared/Typografed';
import { tp } from '@/shared/lib/typograf';
import { TeamPerson } from '../../../../entities/teamPerson';
import ContactUsForm from '../../shared/ContactUsForm';

export type QuestionsSectionProps = {
    title: string;
    description?: string;
    href?: string | null;
    linkText?: string | null;
};

type Props = React.HTMLAttributes<HTMLElement> & {
    questionsSectionProps: QuestionsSectionProps;
    contactPersonProps: TeamPerson | null;
};

const QuestionsSection = ({ questionsSectionProps, contactPersonProps, ...props }: Props) => {
    return (
        <section {...props} className={classNames('questions-section questions-section-wrapper', props.className)}>
            <div className="wrapper">
                <div className="questions-form__top">
                    <div className="questions-form__title h3">
                        <Typografed>{questionsSectionProps.title}</Typografed>
                    </div>

                    <div className="support-wrapper questions__support">
                        {questionsSectionProps.description && (
                            <div
                                className="support__descr text-s"
                                dangerouslySetInnerHTML={{ __html: tp(questionsSectionProps.description) }}
                            ></div>
                        )}
                        {questionsSectionProps.href && (
                            <Button
                                tag={Link}
                                href={questionsSectionProps.href}
                                variant={`outline-dark`}
                                className="btn btn-outline-dark"
                            >
                                {questionsSectionProps.linkText}
                            </Button>
                        )}
                    </div>
                </div>

                <div className="questions-form__bot">
                    <div className="questions-form">
                        <ContactUsForm contactInfo={{ email_to: contactPersonProps?.email }} />
                    </div>
                    {contactPersonProps && (
                        <div className="questions__support-block support__section">
                            <div className="support">
                                <div className="support__item">
                                    <TeamItem tag="div" teamPerson={contactPersonProps} />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default QuestionsSection;
